<!-- filepath: d:\fasa\src\components\home\TestimonialCard.vue -->
<template>
  <div class="testimonial-card">
    <div class="testimonial-content">
      <p>"{{ testimonial }}"</p>
    </div>
    <div class="testimonial-author">
      <h4>{{ name }}</h4>
      <p>{{ company }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialCard',
  props: {
    name: {
      type: String,
      required: true
    },
    company: {
      type: String,
      required: true
    },
    testimonial: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.testimonial-card {
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}

.testimonial-content p {
  font-style: italic;
  margin-bottom: 20px;
  color: #555;
}

.testimonial-author h4 {
  margin-bottom: 5px;
  color: var(--secondary-color);
}

.testimonial-author p {
  color: #777;
  font-size: 14px;
}
</style>